export const DRUM_GAIN_BOOST = 1.4
export const GAIN_BOOST = 1.0
export const GLOBAL_GAIN_BOOST = 1.3
export const MINUS_3DB = 1 / Math.sqrt(2)
export const SAMPLING_RATE = 44100

export const EMPTY_PATH = 'EMPTY_PATH'
